import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import ScrollToTop from './components/ScrollToTop';
import SEOMetaTags from './components/SEOMetaTags';
import { useLanguage } from './contexts/LanguageContext';

function App() {
  const { language } = useLanguage();

  // Track page views for analytics
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-TR9YHY9HMS', {
        page_path: window.location.pathname,
        page_location: window.location.href,
        page_title: document.title
      });
    }
  }, [window.location.pathname]);

  return (
    <Router>
      <ScrollToTop />
      <SEOMetaTags />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Location-specific routes */}
            <Route path="/clinique-simbock" element={<HomePage />} />
            <Route path="/centre-medical-tradex-simbock" element={<ServicesPage />} />
            <Route path="/urgences-simbock" element={<ContactPage />} />
            
            {/* Language routes */}
            <Route path="/fr" element={<HomePage />} />
            <Route path="/en" element={<HomePage />} />
            <Route path="/fr/services" element={<ServicesPage />} />
            <Route path="/en/services" element={<ServicesPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;